import React, { useCallback } from 'react';
import { Link, useMatch } from 'react-router-dom';
import { Nav, Navbar, NavItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LogoutFromPartnerBoard } from '../../store/authSlice';
import { RootState } from '../../store';
import { ManagedPartnerDto } from '../../store/partnerManagerSlice';
import useTranslate from '../useTranslate';
import {
    goToManageAccount,
    goToSelectPartner,
} from '../../nav/navigationService';

interface Props {
    isAdminAccountManager: boolean;
    isReadOnlyAccountManager: boolean;
    nav: boolean;
    hidePartnerSelection: boolean;
    selectedPartner: ManagedPartnerDto;
    canCreateAccountingArea: boolean;
    attachedPartners: ManagedPartnerDto[];

    LogoutFromPartnerBoard: () => void;
    onOpenContact: () => void;
    onOpenHelp: () => void;
}

const noOp = () => {};

function Navigation(props: Readonly<Props>) {
    const strings = useTranslate('Navigation');

    const matchManageAccount = useMatch('/manage-account');
    const matchSelectPartner = useMatch('/select-partner');

    const logout = useCallback(() => {
        props.LogoutFromPartnerBoard();
    }, [props]);

    const hasPartnerActions =
        props.attachedPartners.length > 1 || props.canCreateAccountingArea;
    const showPartnerSelection =
        !props.hidePartnerSelection && hasPartnerActions;

    const isAdminAccountManager = props.isAdminAccountManager;
    const isReadOnlyAccountManager = props.isReadOnlyAccountManager;

    return (
        <Navbar
            fluid
            expanded={false}
            onToggle={noOp}
            className="noprr"
            data-testid="navigation-bar"
        >
            <Navbar.Header>
                <Navbar.Toggle>
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                </Navbar.Toggle>
                <Link
                    className="navbar-brand"
                    title="WeWash. Shine Bright."
                    to="/dashboard"
                >
                    {' '}
                </Link>

                {isAdminAccountManager ? (
                    <span className="navbar-mark-admin" />
                ) : (
                    isReadOnlyAccountManager && (
                        <span className="navbar-mark-admin-read-only" />
                    )
                )}
            </Navbar.Header>

            {props.nav ? (
                <Navbar.Collapse className="nopr">
                    <Nav onSelect={noOp} pullRight>
                        {!props.hidePartnerSelection && (
                            <NavItem
                                onClick={goToManageAccount}
                                eventKey={1}
                                active={Boolean(matchManageAccount)}
                            >
                                {strings.partnerManagerAccount}
                            </NavItem>
                        )}

                        {showPartnerSelection && (
                            <NavItem
                                onClick={goToSelectPartner}
                                eventKey={0}
                                active={Boolean(matchSelectPartner)}
                            >
                                {strings.selectPartner}
                            </NavItem>
                        )}

                        <NavItem
                            onClick={props.onOpenHelp}
                            eventKey={2}
                            active={false}
                        >
                            {strings.help}
                        </NavItem>

                        <NavItem
                            onClick={props.onOpenContact}
                            eventKey={3}
                            active={false}
                        >
                            {strings.contact}
                        </NavItem>

                        <NavItem
                            onClick={logout}
                            eventKey={7}
                            data-testid="logout-button"
                        >
                            {strings.logout}
                        </NavItem>
                    </Nav>
                </Navbar.Collapse>
            ) : null}
        </Navbar>
    );
}

export default connect(
    (store: RootState) => ({
        isAdminAccountManager: store.partnerManager.isAdminAccountManager,
        isReadOnlyAccountManager: store.partnerManager.isReadOnlyAccountManager,
        canCreateAccountingArea: store.partnerManager.canCreateAccountingArea,
        attachedPartners:
            store.partnerManager.getPartnersResult?.partners ?? [],
        selectedPartner: store.partnerManager.selectedPartner,
    }),
    { LogoutFromPartnerBoard }
)(Navigation);
